import { styled } from '@mui/material/styles';

export const InlineLinkWrapper = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  fontWeight: 600
}));
